// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeRegistration {
    padding-top: 10px;
    /* padding-left: 20px; */
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.datePicker {
    padding-top: 5px;

}

/* .timePickerDiv {
    display: flex;
    padding-top: 20px;
} */

.timePicker {
    padding-top: 20px;
    /* padding-right: 20px; */
}

.locationPicker {
    padding-top: 20px;
}

.workedTime {
    display: flex;
    margin-left: 25px;
    /* justify-content: center; */
}

.workedTime p {
    padding-right: 20px;
    font-size: 20px;
}

.hour {
    color: #2d76d0;
    font-weight: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TimeRegistration/TimeRegistration.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;;;GAGG;;AAEH;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".TimeRegistration {\n    padding-top: 10px;\n    /* padding-left: 20px; */\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.datePicker {\n    padding-top: 5px;\n\n}\n\n/* .timePickerDiv {\n    display: flex;\n    padding-top: 20px;\n} */\n\n.timePicker {\n    padding-top: 20px;\n    /* padding-right: 20px; */\n}\n\n.locationPicker {\n    padding-top: 20px;\n}\n\n.workedTime {\n    display: flex;\n    margin-left: 25px;\n    /* justify-content: center; */\n}\n\n.workedTime p {\n    padding-right: 20px;\n    font-size: 20px;\n}\n\n.hour {\n    color: #2d76d0;\n    font-weight: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
